import React from 'react';
import { Link } from 'react-router-dom';
import daily from './../../../Images/daily.png'
import service from './../../../Images/service.png'
import ride from './../../../Images/ride.png'
import HoverCard from 'react-png-hovercard';
import Fade from 'react-reveal/Fade';

const Project = () => {
    return (
        <div className="container mt-5" id="project">
            <div className="row mt-5">
                <h3 className=""><span style={{ borderBottom: '3px solid green' }}>LATEST PROJECT</span></h3>
                <div className="col-md-4 mt-5 p-4">
                    <Fade left>
                        <HoverCard
                            front={
                                <div className="Front">
                                    <img
                                        src={service}
                                        alt=""
                                        style={{ width: '500px', height: '300px' }}
                                        className="img-fluid"
                                    />
                                </div>
                            }
                            back={
                                <div className="Back m-3 justify-content-center align-items-center d-flex">
                                    <p>Project Info</p>
                                    <div className="mt-3">
                                        <a href="https://service-ff551.web.app/"><i className="fas fa-globe fa-2x m-2" style={{ color: '#198754' }}></i></a>
                                        <a href="https://github.com/Rajdev-ullash/Painter_service_client"><i className="fab fa-github fa-2x m-2" style={{ color: '#198754' }}></i></a>
                                        <Link className="btn btn-outline-success m-2" to="/project">Project Details</Link>
                                    </div>
                                </div>
                            }
                            width={500}
                            animationSpeed={500}
                            height={300}
                            margin={10}
                        />
                        <p className="text-center mt-3">Painting Service Type Website</p>
                    </Fade>
                </div>
                <div className="col-md-4 mt-5 p-4">
                    <Fade top>
                        <HoverCard
                            front={
                                <div className="Front">
                                    <img
                                        src={daily}
                                        alt=""
                                        style={{ width: '500px', height: '300px' }}
                                        className="img-fluid"
                                    />
                                </div>
                            }
                            back={
                                <div className="Back m-3 justify-content-center align-items-center d-flex">
                                    <p>Project Info</p>
                                    <div className="mt-3">
                                        <a href="https://daily-needs-f3d44.web.app/"><i className="fas fa-globe fa-2x m-2" style={{ color: '#198754' }}></i></a>
                                        <a href="https://github.com/Rajdev-ullash/Daily-needs-grocery_client"><i className="fab fa-github fa-2x m-2" style={{ color: '#198754' }}></i></a>
                                        <Link className="btn btn-outline-success m-2" to="/project">Project Details</Link>

                                    </div>

                                </div>
                            }
                            width={500}
                            animationSpeed={500}
                            height={300}
                            margin={10}
                        />
                        <p className="text-center mt-3">It's a Grocery type Website</p>
                    </Fade>
                </div>
                <div className="col-md-4 mt-5 p-4">
                    <Fade right>
                        <HoverCard
                            front={
                                <div className="Front">
                                    <img
                                        src={ride}
                                        alt=""
                                        style={{ width: '500px', height: '300px' }}
                                        className="img-fluid"
                                    />
                                </div>
                            }
                            back={
                                <div className="Back m-3 justify-content-center align-items-center d-flex">
                                    <p>Project Info</p>
                                    <div className="mt-3">
                                        <a href="https://gems-of-riders.web.app/"><i className="fas fa-globe fa-2x m-2" style={{ color: '#198754' }}></i></a>
                                        <a href="https://github.com/Rajdev-ullash/Gems-of-riders"><i className="fab fa-github fa-2x m-2" style={{ color: '#198754' }}></i></a>
                                        <Link className="btn btn-outline-success m-2" to="/project">Project Details</Link>
                                    </div>
                                </div>
                            }
                            width={500}
                            animationSpeed={500}
                            height={300}
                            margin={10}
                        />
                        <p className="text-center mt-3">It's a Ride sharing type Website(Gems of riders)</p>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default Project;